import React from "react";
import PageHeader from "../../common/page-header/page-header";
import {
    AssetQuickActionsConfig,
    getAssetStatsCards
} from "./config/asset-dashboard.config";
import type {AssetsCount} from "../../../domains/models/asset-management";
import CategoryBreakdownChart from "./utils/category-breakdown-chart";
import type {AllocationOverdueData} from "./types/asset-dashboard.type";
import QuickAction from "../../common/quick-actions/quick-actions";
import StatCards from "../../common/stat-cards/stat-cards";
import CostBreakdownChart from "./utils/cost-breakdown-chart";
import CostPieChart from "./utils/cost-pie-chart";
import RequestAnalysisChart from "./utils/request-analysis-chart";
import RequestAnalysisPieChart from "./utils/request-analysis-pie-chart";
import {useNavigate} from "react-router-dom";

interface AssetDashboardViewProps {
    assetsCount: AssetsCount;
    allocationOverdueData: AllocationOverdueData;
    loading: boolean
}

function AssetDashboardView(props: AssetDashboardViewProps) {
    // const statsWithValues = getAssetStatsCards(props.assetsCount);


    const navigate = useNavigate();

    const statsWithValues = getAssetStatsCards(
        props.assetsCount,
        navigate
    );

    return (
        <>
            <PageHeader
                title={"Asset Dashboard"}
                description={"Overview of asset management system"}
            />
            <div className="pn-asset__content">

                {/* ----- Asset dashboard stats cards ----- */}
                <StatCards data={statsWithValues} size="small" loading={props.loading}/>
                <div>
                    <CategoryBreakdownChart categories={props.assetsCount.assetCount.categories}/>
                </div>

                <div className="pn-asset__grid__quick-action">
                    <CostBreakdownChart categories={props.assetsCount.costAnalysis.categories}/>
                    <CostPieChart summary={props.assetsCount.costAnalysis.summary}/>
                </div>

                <div className="pn-asset__grid__quick-action">
                    <RequestAnalysisChart categories={props.assetsCount.requestAnalysis.categories}/>
                    <RequestAnalysisPieChart summary={props.assetsCount.requestAnalysis.summary}/>
                </div>

                <QuickAction
                    title="Quick Actions"
                    data={AssetQuickActionsConfig}
                />
                {/*<div className="pn-asset__grid__quick-action">*/}
                {/*<RecentActivity/>*/}
                {/*</div>*/}
            </div>
        </>

    )
}

export default AssetDashboardView;